<template>
  <b-button
    :class="[
      'button',
      {
        'button--has-radius': hasRadius,
        'button--fluid': isFluid,
        'button--active': isActive,
        'button--clear': isClear,
        'button--disabled': isDisabled,
      },
    ]"
    @click="$emit('action')"
  >
    {{ label }}
  </b-button>
</template>

<script>
export default {
  name: 'Button',

  props: {
    label: {
      type: String,
      default: 'button',
    },
    hasRadius: {
      type: Boolean,
      default: false,
    },
    isFluid: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isClear: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  background: transparent;
  color: $white;
  border: 1px solid $white;
  border-radius: 3px;
  padding: rem(12) rem(18);
  font-size: rem(18);
  line-height: 1.25;
  font-weight: $font-regular;
  width: rem(225);
  text-align: center;

  &:focus {
    outline: none !important;
    box-shadow: none !important;
    background: #f5f5f5 !important;
    border: 1px solid $buttonColor;
    color: $buttonColor;
    font-weight: $font-bold;
  }

  &--fluid {
    width: 100%;
  }

  &--active {
    outline: none !important;
    box-shadow: none !important;
    background: #f5f5f5;
    border: 2px solid $buttonColor !important;
    color: $buttonColor !important;
    font-weight: $font-bold;
  }

  &--has-radius {
    border-radius: 3px 3px rem(20) 3px;
  }

  &--clear {
    border-color: rgba($buttonColor, 1);
    color: rgba($buttonColor, 1);
  }

  &--disabled {
    border-color: rgba($buttonColor, 0.3);
    color: rgba($buttonColor, 0.3);
    pointer-events: none;
    cursor: none;

    &:focus {
      background: transparent !important;
    }
  }
}
</style>
